import store from '@/store';

export const InitialAdminPath = () => {
  // Auth is now cookie-based — JWT is not accessible from JavaScript.
  // Read requireBusiness from the Vuex store, populated by the manager
  // factory (/auth/me) before RunAuthRedirects runs.
  const requireBusiness = store.getters['manager/getRequireBusiness'];

  /**
   * Manager has no business
   */
  if (requireBusiness) {
    return '/manager';
  }

  return '/home';
};

export const InitialSuperAdminPath = '/admin/dashboard';
